import styled from "styled-components";

export const CustomSearchContainer = styled.div`

  display: flex;
  align-items: stretch;
  // gap: 15px;
  width: 30%;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  -webkit-box-align: center;
  align-items: center;

  .icon {
    color: var(--secondary-text-color);
  }

  .ant-input {
    height: 42px;
    padding-left: 22px;
  }
  .ant-input:focus {
    border: 1px solid #8a3ef4 !important;
  }

  .ant-input::placeholder {
    color: var(--secondary-text-color);
  }
`;
export const CustomExpandSearchContainer = styled.div`

  display: flex;
  align-items: stretch;
  // gap: 15px;
  width: 20%;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  -webkit-box-align: center;
  align-items: center;

  .icon {
    color: var(--secondary-text-color);
  }

  .ant-input {
    height: 30px;
    padding-left: 22px;
  }
  .ant-input:focus {
    border: 1px solid #8a3ef4 !important;
  }

  .ant-input::placeholder {
    font-size: 12px;
    color: var(--secondary-text-color);
  }
`;
